import IFiltersTypeDescriptor from "./IFiltersDescriptor";

/**
 * Interface for edge parameter type descriptors. These affect the behavior of the parameter card appearance on the Configurator.
 */
interface IEdgeTypeDescriptor {
    editable?: boolean;
    readOnly?: boolean;
    tooltip?: string;
    format?: string;
    filters?: IFiltersTypeDescriptor;
    sideLabels?: { top?: string; bottom?: string; left?: string; right?: string };
    // Ha jelen van, az élzáró-selectorban a láthatóság-alapú gombok (Látható / Takart / Rejtett)
    // is megjelennek az oldal-gombok mellett. Ha hiányzik, csak az oldal-gombok látszanak.
    // (A három él-mező — Visible/Joint/HiddenEdgeProduct — az adat-sémában AKKOR IS létezik,
    //  ha ezek a gombok nincsenek kirakva; lásd ParametersProcessor.)
    visibilityLabels?: { visible?: string; joint?: string; hidden?: string };
}

export default IEdgeTypeDescriptor;
